/**
 * @generated SignedSource<<e6d6f00b12320738af6ae59f7253a53f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedOriginalLanguageProvider_item$data = {
  readonly serviceId: string | null;
  readonly sourceLocale: string | null;
  readonly " $fragmentType": "PdpSharedOriginalLanguageProvider_item";
};
export type PdpSharedOriginalLanguageProvider_item$key = {
  readonly " $data"?: PdpSharedOriginalLanguageProvider_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedOriginalLanguageProvider_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedOriginalLanguageProvider_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceLocale",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7af902047931db06bd420dc431ca02e3";

export default node;
